export default __webpack_public_path__ + "static/media/hvacita.61d04ef5.pdf";